import React from "react";

import ShopsBySuppliersSelectors from "./components/ShopsBySuppliersSelectors";
import SuppliersTable from "./components/SuppliersTable";
import ShopsTable from "./components/ShopsTable.js";

// Головний компонент сторінки "Статуси оновлення магазинів"
const ShopSettingsPage = () => {
  return (
    <section id="shop-settings">
      <div className="settings-content">
        <div className="settings-content-title">
          <h3>Оновлення цін магазинів</h3>
        </div>
        <ShopsBySuppliersSelectors />
      </div>

      <div className="settings-content">
        <SuppliersTable />
      </div>
      <div className="settings-content">
        <ShopsTable />
      </div>
    </section>
  );
};

export default ShopSettingsPage;
